"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function tnt(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M10.4175 15.7522L10.536 18.375C10.536 18.375 11.9422 18.1365 13.407 18.375L13.524 15.7522H10.4175ZM8.7195 13.725C8.7195 13.725 12.8212 13.3672 15.2235 13.725L15.4575 10.8637C13.1759 10.6868 10.8841 10.6868 8.6025 10.8637L8.7195 13.725ZM19.5 6.33295C19.5 6.33295 11.6483 4.66345 4.5 6.4522L5.02725 9.73045L5.67225 8.4787C5.67225 8.4787 12.4103 7.46545 18.4447 8.4787L19.0312 9.7312L19.5 6.33295Z", fill: color }));
}
exports["default"] = tnt;
//# sourceMappingURL=tnt.js.map